import React from 'react'

const CreateNewStockCheck = ({
  handleSubmit,
  handleChange,
  closeModal,
  eventTitle,
  submitting,
}) => {
  return (
    <>
      <div className='text-center h5 shadow-sm pb-3 bg-white rounded'>
        Add Stock Check
      </div>
      <form className='mt-3' onSubmit={handleSubmit}>
        <div className='form-group'>
          <label className='col-sm-12 h6 pt-3'>Title</label>
          <div className='col-sm-12'>
            <input
              type='text'
              name='eventTitle'
              className='form-control mt-2'
              value={eventTitle}
              onFocus={(e) => e.target.select()}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className='text-end mt-4'>
          <button
            type='submit'
            className='btn btn-success btn-sm'
            disabled={submitting || !eventTitle.trim()}
          >
            {submitting ? 'Saving…' : 'Submit'}
          </button>
          <button
            type='button'
            className='btn btn-danger btn-sm ms-3'
            onClick={closeModal}
            disabled={submitting}
          >
            Cancel
          </button>
        </div>
      </form>
    </>
  )
}

export default CreateNewStockCheck
